import types from 'pages/Orders/actions/types';
import { getDefaultOrderListFilter } from 'pages/Orders/helpers/constans';

const INITIAL_STATE = {
  query: { ...getDefaultOrderListFilter(), order_status: -1 },

  loadingList: false,
  activeRequestId: 0,
  dataOrders: {
    items: [],
    itemsPerPage: 0,
    page: 0,
    totalItems: 0,
    totalPages: 0,
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_QUERY_REQUEST:
      return {
        ...state,
        query: action.payload,
      };
    case types.GET_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        activeRequestId: action.meta?.requestId || 0,
      };
    case types.GET_LIST_REQUEST_FAILE:
      if (action.meta?.requestId !== state.activeRequestId) return state;
      return {
        ...state,
        loadingList: false,
      };
    case types.GET_LIST_REQUEST_SUCCESS:
      if (action.meta?.requestId !== state.activeRequestId) return state;
      return {
        ...state,
        loadingList: false,
        dataOrders: action.payload,
      };
    default:
      return state;
  }
}
